import { useCallback } from 'react';
import type React from 'react';
import type { Point } from '../../../../../../common/maths/geometry/pointTypes';

import { getPathIdFromDocumentHitTest } from './drawingEditorHitTestUtils';

type UseDrawingPathHitTestArgs = {
    inputLayerRef?: React.RefObject<HTMLElement>;
    requiredClassName?: string;
};

/**
 * Returns a memoized hit-test function that resolves drawing path ids from a client point.
 */
const useDrawingPathHitTest = ({ inputLayerRef, requiredClassName }: UseDrawingPathHitTestArgs) =>
    useCallback(
        (clientPoint: Point): string | null =>
            getPathIdFromDocumentHitTest({
                clientX: clientPoint.x,
                clientY: clientPoint.y,
                inputLayerNode: inputLayerRef?.current,
                requiredClassName,
            }),
        [inputLayerRef, requiredClassName],
    );

export default useDrawingPathHitTest;
